import {IsString, MinLength} from 'class-validator';

export class ForgotPasswordChangeDto {
  @IsString()
  key!: string;

  @IsString()
  @MinLength(8)
  password!: string;
}
